import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

import { OfferEngagementType } from '@ocx/graphql';
import { SpinWheelGameOffer } from '@ocx/data-offers';
import { logInDev } from '@ocx/utils';

import { SpinWheelFreeGameController } from './SpinWheelFreeGame';
import { SpinWheelVoucheredGameController } from './SpinWheelVoucheredGame';

export type SpinWheelGameControllerProps = {
  offer: SpinWheelGameOffer;
  onLastGameplayEnd(): void;
};

export const SpinWheelGameController = (props: SpinWheelGameControllerProps) => {
  const { offer, onLastGameplayEnd } = props;
  const client = useApolloClient();

  // Gameplay refetches the details query only, so a spent game is still on the offer lists.
  // Refresh them once here rather than on every spin.
  const handleLastGameplayEnd = useCallback(() => {
    client.refetchQueries({ include: ['offers'] }).catch(logInDev);
    onLastGameplayEnd();
  }, [client, onLastGameplayEnd]);

  if (offer.engagementType === OfferEngagementType.GameVoucher) {
    return <SpinWheelVoucheredGameController offer={offer} onLastGameplayEnd={handleLastGameplayEnd} />;
  }

  if (offer.engagementType === OfferEngagementType.Game) {
    return <SpinWheelFreeGameController offer={offer} onLastGameplayEnd={handleLastGameplayEnd} />;
  }

  return null;
};
